const transformErrors = (data) => {
  let errors = {};

  Object.keys(data).forEach((key) => {
    let value = data[key];
    switch (key) {
      case "phone":
        errors["mobileNumber"] = value;
        break;
      default:
        errors[key] = value;
        break;
    }
  });

  return errors;
};

export default function errorHandler(error) {
  if (error.response) {
    if (
      error.response.data &&
      error.response.data.errors &&
      !(error.response.data.errors instanceof Array)
    ) {
      let errors = transformErrors(error.response.data.errors);
      console.log(errors);
      throw errors;
    } else {
      console.log("else");
      console.log(error.response.data);
      throw error.response.data;
    }
  }
}
